var exports = {
  "ST": "FavoritesChannelListContent.module__channelBadgeSelected___NkpGSm",
  "pJ": "FavoritesChannelListContent.module__channelBadgeSelectedIcon___NkpGSm",
  "Vm": "FavoritesChannelListContent.module__favoriteItemContainer___NkpGSm",
  "eb": "FavoritesChannelListContent.module__favoriteItem___NkpGSm",
  "bu": "FavoritesChannelListContent.module__favoriteItemDefault___NkpGSm",
  "Vb": "FavoritesChannelListContent.module__favoriteItemSelected___NkpGSm",
  "q6": "FavoritesChannelListContent.module__favoriteItemOver___NkpGSm",
  "xQ": "FavoritesChannelListContent.module__favoriteItemMuted___NkpGSm",
  "H": "FavoritesChannelListContent.module__avatarContainer___NkpGSm",
  "my": "FavoritesChannelListContent.module__avatar___NkpGSm",
  "rZ": "FavoritesChannelListContent.module__avatarPlaceholder___NkpGSm",
  "XQ": "FavoritesChannelListContent.module__channelBadge___NkpGSm",
  "gg": "FavoritesChannelListContent.module__channelBadgeIcon___NkpGSm",
  "QC": "FavoritesChannelListContent.module__displayName___NkpGSm",
  "Hq": "FavoritesChannelListContent.module__actionsContainer___NkpGSm",
  "af": "FavoritesChannelListContent.module__categoryItem___NkpGSm",
  "Yq": "FavoritesChannelListContent.module__categoryContent___NkpGSm",
  "yb": "FavoritesChannelListContent.module__categoryName___NkpGSm",
  "Yl": "FavoritesChannelListContent.module__categoryIcon___NkpGSm",
  "wp": "FavoritesChannelListContent.module__categoryActions___NkpGSm",
  "Ef": "FavoritesChannelListContent.module__hoverAffordance___NkpGSm",
  "It": "FavoritesChannelListContent.module__categoryAddButton___NkpGSm",
  "n3": "FavoritesChannelListContent.module__categoryAddButtonIcon___NkpGSm",
  "NP": "FavoritesChannelListContent.module__navigationContainer___NkpGSm",
  "r0": "FavoritesChannelListContent.module__channelGroupsContainer___NkpGSm",
  "kj": "FavoritesChannelListContent.module__uncategorizedGroup___NkpGSm",
  "Mn": "FavoritesChannelListContent.module__keyboardFocus___NkpGSm",
};

module.exports = exports;
